













import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  data: () => ({
    overlay: false
  }),
  computed: {
    ...mapGetters({
      currentTrim: 'trims/currentTrim',
      currentModel: 'models/currentModel'
    }),
    truncatedYear() : string {
      const year : string = this.currentModel.year.toString()
      return "'" + year.slice(-2)
    }
  },
  components: {
  }
})
